import { Type } from 'class-transformer';

export class EventDto {
	id: string;
	title: string;
	type: string;
	status: string;
	is_private: boolean;
	category_id: string;
	description?: string | null;
	@Type(() => Date)
	displayed_start_time: Date;
	@Type(() => Date)
	end_date: Date;
	@Type(() => Date)
	opening_time?: Date | null;
	img_variants?: Record<string, string> | null;
	is_odds_locked?: boolean | null;
	has_multiple_lobbies: boolean;
	competition_type?: string | null;
	is_score_hidden?: boolean | null;
	featured?: boolean;
}
